// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "segment-3ZH86";
var _5 = "col-TO4fL";
var _6 = "plane__icon-3BKvs";
var _7 = "city-Gwoqf";
var _8 = "city__airport-1x730";
var _9 = "city__info-2X8LI";
var _a = "city__time-2SYM6";
var _b = "city__weather-1SDiU";
var _c = "weather__icon-2YRV1";
var _d = "flightInfo-qwsYQ";
var _e = "flightInfo__title-i9P5f";
var _f = "flightInfo__value-3st95";
var _10 = "flightInfo__departure-1oxYQ";
var _11 = "airline__logo-cLOUz";
var _12 = "airline__name-3ibVn";
var _13 = "footer__airline-1fCBp";
var _14 = "footer__item-3fE6H";
var _15 = "footer__itemLabel-33Gn2";
var _16 = "footer__itemValue-2ro2M";
var _17 = "button-1Xfdh";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "segment", _5 as "col", _6 as "plane__icon", _7 as "city", _8 as "city__airport", _9 as "city__info", _a as "city__time", _b as "city__weather", _c as "weather__icon", _d as "flightInfo", _e as "flightInfo__title", _f as "flightInfo__value", _10 as "flightInfo__departure", _11 as "airline__logo", _12 as "airline__name", _13 as "footer__airline", _14 as "footer__item", _15 as "footer__itemLabel", _16 as "footer__itemValue", _17 as "button" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "segment": _4, "col": _5, "plane__icon": _6, "city": _7, "city__airport": _8, "city__info": _9, "city__time": _a, "city__weather": _b, "weather__icon": _c, "flightInfo": _d, "flightInfo__title": _e, "flightInfo__value": _f, "flightInfo__departure": _10, "airline__logo": _11, "airline__name": _12, "footer__airline": _13, "footer__item": _14, "footer__itemLabel": _15, "footer__itemValue": _16, "button": _17 }
